export const getOptions = (status: string) => {
  switch (status) {
    case "pending inbound":
      return [
        {
          label: "View details",
          value: "VIEW_DETAILS",
          icon: "/images/eye.svg",
        },
        {
          label: "Edit details",
          value: "EDIT_DETAILS",
          icon: "/images/eye.svg",
        },
        {
          label: "Cancel",
          value: "CANCEL",
          icon: "/images/Download.svg",
        },
      ];
    case "pending outbound":
      return [
        {
          label: "View details",
          value: "VIEW_DETAILS",
          icon: "/images/eye.svg",
        },
        {
          label: "Edit details",
          value: "EDIT_DETAILS",
          icon: "/images/edit.svg",
        },
        {
          label: "Cancel",
          value: "CANCEL",
          icon: "/images/Delete.svg",
        },
      ];
    default:
      return [
        {
          label: "View details",
          value: "VIEW_DETAILS",
          icon: "/images/eye.svg",
        },
      ];
  }
};